import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const Notification = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000); // Se cierra en 3 segundos
    return () => clearTimeout(timer);
  }, [onClose]);

  return createPortal(
    <div 
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "red",
        color: "white",
        padding: "10px 20px",
        borderRadius: "5px",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        fontSize: "16px",
        fontWeight: "bold",
        animation: "fadeIn 0.3s ease-in-out"
      }}
    >
      {message}
    </div>,
    document.body
  );
};

const NotificationProvider = () => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (message) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, message }]);
    setTimeout(() => {
      setNotifications((prev) => prev.filter((notif) => notif.id !== id));
    }, 3000);
  };

  return { 
    addNotification, 
    NotificationContainer: () => (
      <div style={{ position: "fixed", top: "20px", left: "50%", transform: "translateX(-50%)", zIndex: 1000 }}>
        {notifications.map((notif) => (
          <Notification 
            key={notif.id} 
            message={notif.message} 
            onClose={() => setNotifications((prev) => prev.filter((n) => n.id !== notif.id))} 
          />
        ))}
      </div>
    )
  };
};

export default NotificationProvider;
